import Button from "carbon-react/lib/components/button";

const ResetMfaForUser = ({ openResetMfaDialog }) => {
  return (
    <>
      <div>
        <Button
          as="primary"
          destructive
          onClick={openResetMfaDialog}
          className="resetMfaButton"
        >
          Reset MFA for user
        </Button>
      </div>
    </>
  );
};

export default ResetMfaForUser;
